import {useCallback, useMemo, useState} from "react";
import * as PropTypes from "prop-types";
import {makeStyles} from "@material-ui/core/styles";
import EditTablePatient from "../../../components/EditableTable/EditTablePatient";
import DeletePatientModal from "containers/PatientDataPage/DeletePatientModal";
import { AbdContext } from "../PatientDataPage";
import { useContext } from "react";

const useStyles = makeStyles(theme => ({
  wrapper: {
    width: "100%",
    padding: "20px 40px 0px 40px",
  },
}));

export function PatientDataComponent({
  patient = { address: {} },
  onUpdatePatient,
  insurers = [],
  dentists = [],
  onDeletePatient,
  deleteMessage,
  onReset,
  onCreateDentist,
}) {
  const classes = useStyles();

  const [patientData, setPatientData] = useState(patient);
  const [editable, setEditable] = useState(true);
  const [isOpen, setIsOpen] = useState(false);

  const changes = { name: "label", id: "value" };

  const insurer = useMemo(
    () => {
      if (patientData) {
        return insurers.find(i => i.id === patientData.careId);
      }
    },
    [insurers, patientData],
  );

  const dentist = useMemo(
    () => {
      if (patientData) {
        return dentists.find(d => d.id === patientData.dentistId);
      }
    },
    [dentists, patientData],
  );

  // Modified for the Custom DropDown components
  const selectedInsurerModified = useMemo(
    () =>
      Object.assign(
        {},
        ...Object.entries(insurer || {}).map(([prevKey, val]) => ({
          [changes[prevKey]]: val,
        })),
      ),
    [changes, insurer],
  );
  const selectedDentistModified = useMemo(
    () =>
      Object.assign(
        {},
        ...Object.entries(dentist || {}).map(([prevKey, val]) => ({
          [changes[prevKey]]: val,
        })),
      ),
    [changes, dentist],
  );

  // ??? have to check random undefined!
  delete selectedDentistModified.undefined;

  const handleSave = useCallback(
    () => {
        onUpdatePatient(patientData);
    },
    [editable, onUpdatePatient, patientData],
  );

  let {showupdatepatient,setshowupdatepatient} = useContext(AbdContext)

  return (
    <div className={classes.wrapper}>
      <EditTablePatient
        patient={patientData}
        dentists={dentists.map(({ name, id }) => ({
          label: name,
          value: id,
        }))}
        onCreateDentist={onCreateDentist}
        selectedDentist={selectedDentistModified}
        selectedInsurer={selectedInsurerModified}
        insurers={insurers.map(({ name, id }) => ({
          label: name,
          value: id,
        }))}
        insurer={insurer}
        dentist={dentist}
        editable={editable}
        onPatientChange={setPatientData}
        onDelete={() => setIsOpen(true)}
        onButtonClick={() => {
          handleSave();
          setEditable(!editable);
          setshowupdatepatient(false)
        }}
      />
      {!!onDeletePatient && (
        <DeletePatientModal
          isOpen={isOpen}
          onClose={() => {
            setIsOpen(false);
            onReset();
          }}
          onConfirm={() => onDeletePatient(patient)}
          dataCy="deleteModal"
          deleteMessage={deleteMessage}
        />
      )}
    </div>
  );
}

PatientDataComponent.propTypes = {
  patient: PropTypes.object,
  onUpdatePatient: PropTypes.func,
  onDeletePatient: PropTypes.func,
  onReset: PropTypes.func,
  dentists: PropTypes.array,
  insurers: PropTypes.array,
  deleteMessage: PropTypes.any,
};
